import { type Components, type Theme, toggleButtonClasses, toggleButtonGroupClasses } from '@mui/material'

/**
 * MUI ToggleButton & ToggleButtonGroup Component Overrides
 * Used for segmented control components like TypeSelector and Metrics
 */

export const MuiToggleButtonGroup: Components<Theme>['MuiToggleButtonGroup'] = {
    styleOverrides: {
        root: ({ theme }) => ({
            display: 'inline-flex',
            alignItems: 'center',
            padding: 4,
            borderRadius: 4,
            border: `1px solid ${theme.palette.grey[300]}`,
            backgroundColor: theme.palette.grey[100],
            height: 32,
        }),
    },
}

export const MuiToggleButton: Components<Theme>['MuiToggleButton'] = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: ({ theme }) => ({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0px 8px',
            borderRadius: 2,
            border: '1px solid transparent',
            backgroundColor: 'transparent',
            textTransform: 'none',
            fontSize: 12,
            fontWeight: 400,
            marginLeft: 0,
            color: theme.palette.grey[500],
            height: 24,
            gap: 4,
            lineHeight: '18px',
            letterSpacing: 'normal',

            [`&.${toggleButtonClasses.selected}`]: {
                border: `1px solid ${theme.palette.grey[200]}`,
                backgroundColor: theme.palette.common.white,
                color: theme.palette.grey[900],
                borderRadius: 2,
            },

            [`&:hover:not(.${toggleButtonClasses.selected})`]: {
                backgroundColor: theme.palette.grey[200],
                borderRadius: 2,
                color: theme.palette.grey[700],
            },

            // Override for middle button
            [`&.${toggleButtonGroupClasses.middleButton}`]: {
                marginLeft: 0,
            },
        }),
    },
}
